var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-block"},[_c('ul',{staticClass:"columns-block"},_vm._l((6),function(item){return _c('li',{key:item,staticClass:"column"},[_c('PuSkeleton',{staticClass:"skeleton-input"})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }